import React, { Component } from "react";
import { Button } from "antd";
import Congrats_Icons from "../../images/icons/congrats_icon.png";
import bg_onboarding from "../../images/icons/bg_onboarding.png";
import { QBO_APP_BASE_URL } from "../../utils/constants";

function FirstConnectToQbo(props) {
  const { compId } = props;
  function connectQBO(e) {
    window.open(
      QBO_APP_BASE_URL + "/oauthlogin.php?companyId=" + compId,
      "_self"
    );
  }

  return (
    <div
      className="
      h-screen w-full  bg-cover bg-center lg:bg-cover lg:bg-no-repeat bg-no-repeat
      grid grid-cols-12"
      style={{
        backgroundImage: `url(${bg_onboarding})`,
        flexBasis: 0,
        flexGrow: 3,
      }}
    >
      {/* <img className="h-full w-full object-cover bg-no-repeat" src={bg_onboarding} /> */}

      {/* 1st half */}
      <div className="col-span-6">
        {/* <img className="w-full h-screen" src={LeftSide_Step1} alt="welcome image"/> */}
      </div>

      {/* 2nd half */}
      <div className="h-full col-span-6  w-full ">
        <div className="w-full h-full flex items-center justify-center">
          {/* <div className="flex gap-2 justify-center mt-32">
            <img className="h-7 w-7" src={Congrats_Icons} />
            <h1 className="font-poppins font-normal text-3xl h-4">Welcome to KickStart Connector!</h1>
          </div> */}

          <div className="h-436 w-668 border-2 mx-6  rounded-lg bg-white">
            <div className="mt-36 h-20">
              <h1 className="font-raleway text-3xl flex justify-center ">
              Connect Your Store with
              </h1>
              <h1 className="font-raleway font-bold  text-3xl flex justify-center">
                QuickBooks Online
              </h1>
            </div>

            <div className="w-full flex justify-center">
              <div className="w-68 mt-8">
                {/* <Button
                  type="primary"
                  size="large"
                  // ghost
                  block
                  onClick={(e) => {
                    connectQBO(e);
                  }}
                >
                  Connect
                </Button> */}
                <button  
                  onClick={(e) => {
                     connectQBO(e);
                    }}
                >
                   
                  <img
                   src={require("../../images/icons/connectToQuickButton.png")}
                    />
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FirstConnectToQbo;
